export default __webpack_public_path__ + "static/media/IOTCloud300.5c179a82.jpg";